import React, {
  ReactElement, useCallback, useEffect, useState,
} from 'react';
// SLASLX-3400: import from /lib/ (CommonJS) not /es/ (ESM). slovlex-idsk-react-components
// 1.13.16 ships PredpisSearchStepEnum as a real export, and Jest with CRA defaults
// doesn't transform node_modules — so the /es/ ESM path triggers
// "SyntaxError: Unexpected token 'export'" in tests. The /lib/ CommonJS path has
// the same tree but Jest can require() it without transformation.
// eslint-disable-next-line max-len
import PredpisSearch from 'slovlex-idsk-react-components/lib/slovlex-idsk-react-components/components/PredpisSearchModal/model/PredpisSearch';
// eslint-disable-next-line max-len
import PredpisSearchStepEnum from 'slovlex-idsk-react-components/lib/slovlex-idsk-react-components/components/PredpisSearchModal/model/PredpisSearchStepEnum';
// eslint-disable-next-line max-len
import PredpisSearchModal from 'slovlex-idsk-react-components/lib/slovlex-idsk-react-components/components/PredpisSearchModal/PredpisSearchModal';
import { Loader } from 'idsk-react-components';
import { Message } from 'slovlex-idsk-react-components';
import {
  getSearchData,
} from '../../client/external/indexer/vyhladavanieVyberPredpisuClient';
import { SafeParameterSetter } from '../../types/SafeParameterSetter';
import {
  getChronologickyRegisterZakonovRocnikHtmlContent,
} from '../../client/external/static/chronologickyRegisterZakonovRocnikClient';
import {
  getChronologickyRegisterZakonovHistoriaHtmlContent,
} from '../../client/external/static/chronologickyRegisterZakonovHistoriaClient';
import {
  getChronologickyRegisterZakonovDetailObsahHtmlContent,
} from '../../client/external/static/chronologickyRegisterZakonovDetailClient';
import { getYearList } from '../../client/external/static/yearListClient';

interface PropsVybranyPredpisResult {
  setUpdateVybranyPredpis: (cislo: string, iri: string, fullName: string) => void;
  headers?: object ;
}

interface Props {
  nazov: string;
  iri: string;
}

const PredpisSearchModalComponent = ({ setUpdateVybranyPredpis, headers }: PropsVybranyPredpisResult): ReactElement => {
  const [yearList, setYearList] = useState<string[]>();
  const [htmlDataStep2, sethtmlDataStep2] = useState<string>('');
  const [htmlDataStep3, sethtmlDataStep3] = useState<string>('');
  const [htmlDataStep4, sethtmlDataStep4] = useState<string>('');

  const [dataVyhladavanie, setDataVyhladavanie] = useState<Props[]>([]);
  const [dataVyhladavanieStatus, setDataVyhladavanieStatus] = useState<{ loading: boolean; responseCode?: number }>(
    { loading: false },
  );

  const updateSearchResults = useCallback(async (
    value: string,
    dataProp: Props[],
  ) => {
    try {
      const response = await getSearchData(
        value,
        '/vyhladavanie/predpisZbierky/navrhy',
        '/ezbierky/pravne-predpisy',
        { headers },
      );
      const newData = response.data || [];
      setDataVyhladavanie(newData);
      setDataVyhladavanieStatus({
        loading: response.responseCode !== 200,
        responseCode: response.responseCode,
      });
      dataProp.splice(0, dataProp.length, ...newData);
    } catch (error) {
      setDataVyhladavanie([]);
      setDataVyhladavanieStatus({
        loading: false,
        responseCode: error,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [predpisSearch, setPredpisSearch] = useState<PredpisSearch>({
    rok: '',
    cislo: '',
    ucinnost: '',
    vyber: '',
    activeStep: PredpisSearchStepEnum.STEP_1_ROK_OR_CISLO,
  });

  const updateField: SafeParameterSetter<PredpisSearch> = async (fieldName, value) => {
    if (predpisSearch.activeStep === PredpisSearchStepEnum.STEP_4_VYBER && fieldName === 'activeStep') {
      sethtmlDataStep4('');
    }

    if (predpisSearch.activeStep === PredpisSearchStepEnum.STEP_1_ROK_OR_CISLO
      && predpisSearch.rok !== ''
      && predpisSearch.cislo === '') {
      getChronologickyRegisterZakonovRocnikHtmlContent(
        predpisSearch.rok,
      )
        .then((response) => {
          const newData: string = response.data;
          sethtmlDataStep2(newData);
        })
        .catch(() => {
          sethtmlDataStep2('');
        });
    }

    if (predpisSearch.activeStep === PredpisSearchStepEnum.STEP_1_ROK_OR_CISLO
      && predpisSearch.rok !== ''
      && predpisSearch.cislo !== '') {
      getChronologickyRegisterZakonovRocnikHtmlContent(
        predpisSearch.rok,
      )
        .then((response) => {
          const newData: string = response.data;
          sethtmlDataStep2(newData);
        })
        .catch(() => {
          sethtmlDataStep2('');
        });
      getChronologickyRegisterZakonovHistoriaHtmlContent(
        predpisSearch.rok,
        predpisSearch.cislo,
      )
        .then((response) => {
          const newData: string = response.data.response;
          sethtmlDataStep3(newData);
        })
        .catch(() => {
          sethtmlDataStep3('');
        });
    }

    if (predpisSearch.activeStep === PredpisSearchStepEnum.STEP_2_CISLO_PREDPISU) {
      getChronologickyRegisterZakonovHistoriaHtmlContent(
        predpisSearch.rok,
        predpisSearch.cislo,
      )
        .then((response) => {
          const newData: string = response.data.response;
          sethtmlDataStep3(newData);
        })
        .catch(() => {
          sethtmlDataStep3('');
        });
    }
    if (predpisSearch.activeStep === PredpisSearchStepEnum.STEP_3_UCINNOST
      && predpisSearch.rok && predpisSearch.cislo && predpisSearch.ucinnost && fieldName === 'activeStep') {
      await getChronologickyRegisterZakonovDetailObsahHtmlContent(
        predpisSearch.rok,
        predpisSearch.cislo,
        predpisSearch.ucinnost,
      )
        .then((response) => {
          const newData: string = response.data.response;
          sethtmlDataStep4(newData);
        })
        .catch(() => {
          sethtmlDataStep4('');
        });
    }

    setPredpisSearch((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  const setVybranyPredpisValue = useCallback((cislo: string, iri: string, fullName: string) => {
    setUpdateVybranyPredpis(cislo, iri, fullName);
  }, [setUpdateVybranyPredpis]);

  useEffect(() => {
    getYearList()
      .then((response) => {
        const newData: string[] = response.data;
        setYearList(newData);
      })
      .catch(() => {
        setYearList([]);
      });
  }, []);

  return (
    <>
      <Loader loading={dataVyhladavanieStatus.loading}>
        {(dataVyhladavanieStatus.responseCode && dataVyhladavanieStatus.responseCode > 399)
          ? (
            <Message type="error">
              Nepodarilo sa načítať záznamy.
            </Message>
          )
          : (
            <PredpisSearchModal
              htmlContentStep2={htmlDataStep2}
              htmlContentStep3={htmlDataStep3}
              htmlContentStep4={htmlDataStep4}
              yearList={yearList}
              propsSearchResults={dataVyhladavanie}
              updateSearchResults={updateSearchResults}
              predpisSearch={predpisSearch}
              updateField={updateField}
              setUpdateVybranyPredpis={setVybranyPredpisValue}
              reactAppSubpath={process.env.REACT_APP_SUBPATH}
            />
          )}
      </Loader>
    </>
  );
};

export default PredpisSearchModalComponent;
